import type { IconSvgObject } from './types';

const EaseInIcon: IconSvgObject = [
  ["path", { d: "M21 4C21 4 14 20 3 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default EaseInIcon;
